import { gql } from '@apollo/client';

export const EVENT_LIST_INFO = gql`
  query MyQuery($page: Int!, $size: Int!, $eventType: EventPhases!) {
    discoverEvents(page: $page, size: $size, eventType: $eventType) {
      totalCount
      events {
        categories
        currentMilestoneType
        description
        eventType
        id
        likeCount
        liked
        milestoneDate
        milestoneLabel
        name
        promotionalText
        slug
        sponsorId
        sponsorName
        summary
        hashtag
        heroAsset {
          assetId
          basename
          description
          hlsPlaylistUrl
          mimeType
          mp4Url
          thumbnailUrl
          type
          url
          webmUrl
        }
      }
    }
  }
`;
